module.exports = __webpack_public_path__ + "img/03.b36c326c.png";